import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import React, { useState } from "react"
import { View } from "react-native"
import { ToolboxProgram } from "./ToolboxProgram"
import { ToolboxFollowUp } from "./ToolboxFollowUp"
import { CustomTab } from "@Components/CustomTab/CustomTab"

export const ToolBoxForm = ({ navigation }) => {
    const [currentScreen, setCurrentScreen] = useState("Programme")

    return (
        <ContainerStackScreen>
            <CustomScrollview>
                <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                    Activités physiques
                </BreeSerifText>
                <Spacer height={15} />
                <OpenSansText fontSize={16}>
                    Remplissez votre programme physique grâce au tableau prévisionnel puis remplissez votre tableau de
                    suivi après chaque activité.
                </OpenSansText>
                <Spacer height={10} />
                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                    <CustomTab
                        value={"Programme"}
                        currentScreen={currentScreen}
                        onPress={() => setCurrentScreen("Programme")}
                        title={"Programme"}
                    />
                    <CustomTab
                        value={"Suivi"}
                        currentScreen={currentScreen}
                        onPress={() => setCurrentScreen("Suivi")}
                        title={"Suivi"}
                    />
                </View>
                {currentScreen === "Programme" ? <ToolboxProgram navigation={navigation} /> : <ToolboxFollowUp />}
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
